// extracted by mini-css-extract-plugin
export default {"continer":"Spinner_continer__RU7TR","loader":"Spinner_loader__6-BiK","load6":"Spinner_load6__pvV9r","round":"Spinner_round__G2rTk"};